import { Repository } from "src/firebase/firestore/repository";
import { AiSession } from "../types/ai-session.entity";

class AISessionRepository extends Repository<AiSession> {
  constructor() {
    super("ai_sessions");
  }

  async findById(id: string): Promise<AiSession | null> {
    return await super.findById(id) as AiSession | null;
  }

  async find(args: any): Promise<(AiSession & { id: string })[]> {
    return await super.find(args) as (AiSession & { id: string })[];
  }

  async count(where?: any): Promise<number> {
    return await super.count(where);
  }

}

export const aiSessionRepository = new AISessionRepository();
